import { render } from "./DeepSeaHeader.vue?vue&type=template&id=0531c48c"
import script from "./DeepSeaHeader.vue?vue&type=script&lang=js"
export * from "./DeepSeaHeader.vue?vue&type=script&lang=js"

import "./DeepSeaHeader.vue?vue&type=style&index=0&id=0531c48c&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__